import React from 'react';

const SvgActions87 = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 21 18" ref={svgRef}  {...{ ...{ width: '1em', height: '1em' }, ...props }}>
    <title>{title}</title>
    <path d="M13.998 9a2 2 0 1 0-4 0 2 2 0 0 0 4 0zm7 0a9 9 0 0 0-18 0H.708a.49.49 0 0 0-.36.15l-.2.2a.5.5 0 0 0 0 .71l3.53 3.54a.51.51 0 0 0 .71 0l3.53-3.54a.5.5 0 0 0 0-.71l-.2-.2a.49.49 0 0 0-.36-.15h-2.36a7 7 0 1 1 7 7 6.91 6.91 0 0 1-3.88-1.18.5.5 0 0 0-.63.06l-.72.73a.5.5 0 0 0 .07.76 8.89 8.89 0 0 0 5.16 1.63 9 9 0 0 0 9-9z" fill="currentColor" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgActions87 svgRef={ref} {...props} />);
export default ForwardRef;
